import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'

export default {
  /**
   * 获取包机明细
   * @param {Int} pageNum 每页条数
   * @param {Int} pageSize 当前页
   * @param {Int} [userId] 用户id
   * @param {String} [userName] 用户名
   */
  queryPackNode (params) {
    return axios.post('/api/rendering/admin/task/pack/queryPackNode', params)
  },
  /**
   * 导出包机明细
   * @param {*} 同上
   */
  exportPackNode (params) {
    return exportAxios('/api/rendering/admin/task/pack/exportPackNode', params)
  },
  /**
   * 修改包机
   * @param {String} userName 用户名
   * @param {Int} userId 用户ID
   * @param {String} startTime 开始时间
   * @param {String} endTime 结束时间
   * @param {Int} nodeLimit 机器数量
   * @param {String} properties 机器属性
   * @param {String} requirements 机器要求
   * @param {String} fee 包机费用
   * @param {Int} currency 币种 1；RMB 2:USD
   * @param {Int} platform 平台
   * @param {String} remark 备注
   */
  saveOrUpdatePackNode (params) {
    return axios.post('/api/rendering/admin/task/pack/saveOrUpdatePackNode', params)
  },
  /**
   * 删除包机
   * @param {Int} id id
   * @param {Int} userId 用户id
   */
  deletePackNode (params) {
    return axios.post('/api/rendering/admin/task/pack/deletePackNode', params)
  },
  /**
   * 获取包项目明细
   * @param {Int} pageNum 每页条数
   * @param {Int} pageSize 当前页
   * @param {Int} [userId] 用户id
   * @param {String} [userName] 用户名
   */
  queryPackProject (params) {
    return axios.post('/api/rendering/admin/task/pack/queryPackProject', params)
  },
  /**
   * 导出包项目明细
   * @param {*} 同上
   */
  exportPackProject (params) {
    return exportAxios('/api/rendering/admin/task/pack/exportPackProject', params)
  },
  /**
   * 修改包项目
   * @param {String} userName 用户名
   * @param {Int} userId 用户ID
   * @param {String} startTime 开始时间
   * @param {String} endTime 结束时间
   * @param {Int} totalFrames 总帧数
   * @param {Int} projectId 项目Id
   * @param {String} projectName 项目名称
   * @param {String} projectDesc 项目描述
   * @param {Int} renderDuration 渲染时长
   * @param {Int} fee 包项目费用
   * @param {Int} currency 币种 1；RMB 2:USD
   * @param {Int} platform 平台
   */
  saveOrUpdatePackProject (params) {
    return axios.post('/api/rendering/admin/task/pack/saveOrUpdatePackProject', params)
  },
  /**
   * 删除包项目
   * @param {Int} id id
   * @param {Int} userId 用户id
   */
  deletePackProject (params) {
    return axios.post('/api/rendering/admin/task/pack/deletePackProject', params)
  },
  /**
   * 获取租赁明细
   * @param {Int} pageNum 每页条数
   * @param {Int} pageSize 当前页
   * @param {Int} [userId] 用户id
   * @param {String} [userName] 用户名
   */
  queryNodeRentals (params) {
    return axios.post('/api/rendering/admin/task/node/rent/queryNodeRentals', params)
  },
  /**
   * 导出租赁明细
   * @param {*} 同上
   */
  exportNodeRentals (params) {
    return exportAxios('/api/rendering/admin/task/node/rent/exportNodeRentals', params)
  },
  /**
   * 修改租赁
   * @param {String} userName 用户名
   * @param {Int} userId 用户ID
   * @param {Int} amount 数量
   * @param {String} totalCost 租期内总费用
   * @param {Int} overdueUnitPrice 超期单价
   * @param {String} [remark] 备注
   * @param {Int} currency 币种 1；RMB 2:USD
   * @param {String} startTime 开始时间
   * @param {String} endTime 结束时间
   */
  addOrUpdateNodeRental (params) {
    return axios.post('/api/rendering/admin/task/node/rent/addOrUpdateNodeRental', params)
  },
  /**
   * 删除租赁
   * @param {Int} id id
   * @param {Int} userId 用户id
   */
  deleteNodeRental (params) {
    return axios.post('/api/rendering/admin/task/node/rent/deleteNodeRental', params)
  },
}
